var map = {
	"./ConfirmationDialog": 71906,
	"./ConfirmationDialog.jsx": 71906,
	"./EmployeeCard": 60447,
	"./EmployeeCard.jsx": 60447,
	"./MainCard": 6584,
	"./MainCard.js": 6584,
	"./SubCard": 30377,
	"./SubCard.jsx": 30377,
	"./TestTypeCard": 95347,
	"./TestTypeCard.jsx": 95347,
	"./account/AccountsCard": 84987,
	"./account/AccountsCard.jsx": 84987,
	"./branchdashboard/BranchData": 24506,
	"./branchdashboard/BranchData.jsx": 24506,
	"./branchdashboard/RevenueCard": 10090,
	"./branchdashboard/RevenueCard.jsx": 10090
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86759;